var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJunction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2538_934993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.66406 22.0782L11.2227 19.0566C12.6385 19.5602 16.291 20.2652 19.5748 19.0566L24.9054 22.0782M28.8107 19.9118L23.6797 16.7476C24.4208 15.978 25.4584 13.9256 23.6797 11.8732L28.5256 8.85156",
    stroke: "#F7FAFC",
    strokeWidth: 1.82387
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8424 6.57031L19.5688 9.64893C18.001 9.20234 14.09 8.57711 10.9886 9.64893L5.65802 6.57031M1.78125 8.85077L6.85526 11.8439C6.21864 12.414 5.32736 14.2098 6.85526 16.8324L1.98079 20.3386",
    stroke: "#F7FAFC",
    strokeWidth: 1.82387
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.3203,
    cy: 14.3251,
    rx: 10.0625,
    ry: 5.38758,
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8886 12.1553C21.786 12.0602 21.6258 12.0661 21.5306 12.1687C21.529 12.1704 21.5274 12.1722 21.5258 12.1739C20.6577 11.453 19.3652 10.893 17.8381 10.5957C17.8382 10.5949 17.8384 10.594 17.8385 10.5931C17.8624 10.4553 17.77 10.3242 17.6321 10.3003C16.9028 10.1741 16.126 10.1061 15.3205 10.1061C14.5149 10.1061 13.7381 10.1741 13.0088 10.3003C12.871 10.3242 12.7786 10.4553 12.8024 10.5931C12.8026 10.594 12.8027 10.5949 12.8029 10.5957C11.2757 10.893 9.98324 11.453 9.11512 12.1739C9.11356 12.1722 9.11198 12.1704 9.11036 12.1687C9.0152 12.0661 8.85492 12.0602 8.75237 12.1553C8.08947 12.7705 7.68418 13.5099 7.68418 14.3217C7.68418 15.1335 8.08947 15.8728 8.75237 16.488C8.85492 16.5832 9.0152 16.5772 9.11036 16.4746C9.11198 16.4729 9.11356 16.4712 9.11512 16.4694C9.98324 17.1903 11.2757 17.7503 12.8029 18.0476C12.8027 18.0485 12.8026 18.0493 12.8024 18.0502C12.7786 18.1881 12.871 18.3192 13.0088 18.343C13.7381 18.4693 14.5149 18.5373 15.3205 18.5373C16.126 18.5373 16.9028 18.4693 17.6321 18.343C17.77 18.3192 17.8624 18.1881 17.8385 18.0502C17.8384 18.0493 17.8382 18.0485 17.8381 18.0476C19.3652 17.7503 20.6577 17.1903 21.5258 16.4694C21.5274 16.4712 21.529 16.4729 21.5306 16.4746C21.6258 16.5772 21.786 16.5832 21.8886 16.488C22.5515 15.8728 22.9568 15.1335 22.9568 14.3217C22.9568 13.5099 22.5515 12.7705 21.8886 12.1553Z",
    stroke: "#F7FAFC",
    strokeWidth: 0.506631,
    strokeLinecap: "round",
    strokeDasharray: "4.05 4.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.125 8.61719L5.40316 6.70731L10.3346 9.64339L6.79993 11.3822L2.125 8.61719Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5312 20.1016L25.267 22.0592L20.1438 19.1266L23.6753 17.34L28.5312 20.1016Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1953 9.60156L23.497 11.4955L28.5623 8.46398L24.9968 6.74626L20.1953 9.60156Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 20.1484L5.37199 22.0424L10.4373 19.0109L6.87176 17.2931L2.07031 20.1484Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 15.2917,
    cy: 14.8347,
    rx: 3.70574,
    ry: 2.36597,
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1.55551 10.4415L1.66952 9.04467L6.42998 11.8382L5.85986 12.9214L1.55551 10.4415Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1.59657 21.2785L1.70858 19.8806L6.48836 22.6847L5.91831 23.7679L1.59657 21.2785Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M19.6413 20.871L19.6695 19.4275L25.2625 22.6747L24.6951 23.7593L19.6413 20.871Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86058 22.3621L11.1341 19.3976L11.0771 20.8513L5.9461 23.8444L5.86058 22.3621Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4848 22.4395L28.9853 19.9793L29.0361 21.3627L24.6649 23.8601L24.4848 22.4395Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M29.0892 10.3901L24.7022 13.0092L24.0751 11.8975L28.9265 8.96735L29.0892 10.3901Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M19.4588 19.4559C16.6994 20.14 12.798 19.7409 11.1921 19.4559L11.0781 20.9097C13.7235 21.9359 17.8435 21.3372 19.5728 20.9097V19.4559C20.6845 19.1708 22.2181 18.7717 19.4588 19.4559Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2812 10.9545L26.2697 8.04688",
    stroke: "white",
    strokeWidth: 0.3,
    strokeDasharray: "1.11 1.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4376 20.7908L21.335 17.8832M4.20312 7.90625L9.1061 10.7853M4.63071 20.5628L8.93507 18.0543",
    stroke: "white",
    strokeWidth: 0.3,
    strokeDasharray: "1.11 1.11"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.2917,
    cy: 14.2644,
    rx: 3.70574,
    ry: 2.36597,
    fill: "#10B981"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2538_934993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJunction);
export default __webpack_public_path__ + "static/media/junction.5d8b6565aa8376d670677b4ac4c16746.svg";
export { ForwardRef as ReactComponent };